import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

export default function TechnicianRatings() {
  const [averages, setAverages] = useState({});
  const [technicianPhone, setTechnicianPhone] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate(); // ✅ ab use karenge

  useEffect(() => {
    const phone = localStorage.getItem("technicianPhone");
    if (phone) {
      setTechnicianPhone(phone.trim());
    }

    const fetchRatings = async () => {
      try {
        const res = await fetch(AIRTABLE_URL, {
          headers: AIRTABLE_HEADERS,
        });

        const json = await res.json();
        const records = json.records || [];

        // Filter valid ratings
        const validRatings = records
          .filter(
            (rec) =>
              rec.fields.assignedTechnicianPhone &&
              rec.fields.rating &&
              !isNaN(parseInt(rec.fields.rating))
          )
          .map((rec) => ({
            phone: rec.fields.assignedTechnicianPhone.trim(),
            rating: parseInt(rec.fields.rating),
          }));

        // Group and calculate averages
        const ratingMap = {};
        validRatings.forEach(({ phone, rating }) => {
          if (!ratingMap[phone]) ratingMap[phone] = { total: 0, count: 0 };
          ratingMap[phone].total += rating;
          ratingMap[phone].count += 1;
        });

        const avgMap = {};
        Object.entries(ratingMap).forEach(([phone, info]) => {
          avgMap[phone] = (info.total / info.count).toFixed(2);
        });

        setAverages(avgMap);
      } catch (err) {
        console.error("❌ Error fetching ratings from Airtable:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRatings();
  }, []);

  if (loading) return <p>Loading ratings...</p>;

  const isTechnician = !!technicianPhone;
  const technicians = isTechnician
    ? [technicianPhone]
    : Object.keys(averages);

  return (
    <div style={{ padding: 40, position: "relative" }}>
      {/* X Button */}
      <button
        onClick={() => navigate("/technician-home")}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "none",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
          color: "black",
        }}
        title="Close"
      >
        ✖
      </button>

      <h2>{isTechnician ? "My Rating" : "All Technician Ratings"}</h2>
      {technicians.length === 0 ? (
        <p>No ratings available.</p>
      ) : (
        <ul>
          {technicians.map((phone) => (
            <li key={phone}>
              <b>{phone}</b>: ⭐ {averages[phone]} / 5
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
